import app from '../firebase';
import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore';
import { useState, useEffect }  from 'react';
import { AiFillCar }            from "react-icons/ai";
import { FaBed, FaShower }      from "react-icons/fa";
import { BsRulers }             from 'react-icons/bs';
import apartment                from '../media/apartment.png';
import commercial               from '../media/commercial.png';
import condominium              from '../media/condominium.png';
import foreclosure              from '../media/foreclosure.png';
import land                     from '../media/land.png';
import lot                      from '../media/lot.png';

export default function Properties() {

    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'PHP' });

    const [properties, setProperties] = useState();
    const [propertyCategories, setPropertyCategories] = useState();
    const [category, setCategory] = useState();

    const getProperties = async () => {
        let x = [];

        if (!category || category.length === 0 || category === '' || category === ' ') {
            await getDocs(collection(getFirestore(app), 'properties'))

            .then(results => {
                results.forEach(result => x.push([result.id, result.data()]))
            });
        }

        else {
            await getDocs(query(collection(getFirestore(app), 'properties'), where('category', '==', category)))

            .then(results => {
                results.forEach(result => x.push([result.id, result.data()]))
            });
        }

        setProperties(x);
    }

    const getPropertyCategories = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'property_categories'))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        setPropertyCategories(x);
    }

    useEffect(() => {
        console.log('Working')
        getProperties();
        getPropertyCategories();
    }, [category]);

    return(
        <>
            <div className="container-fluid min-vh-100 bg-light p-4">
                <h2>Properties</h2>

                <br />

                <div className="container">
                <div className="row g-4 text-center px-5">

                    <div className="col-4 col-md-2">
                        <div className="h-100 p-2">
                            <img src={apartment} className="img-fluid" style={{ width: 100 }}  alt="" role="button" onClick={() => setCategory('Apartment')} />
                        </div>
                    </div>

                    <div className="col-4 col-md-2">
                        <div className="h-100 p-2">
                            <img src={commercial} className="img-fluid" style={{ width: 100 }}  alt="" role="button" onClick={() => setCategory('Commercial')} />
                        </div>
                    </div>

                    <div className="col-4 col-md-2">
                        <div className="h-100 p-2">
                            <img src={condominium} className="img-fluid"  style={{ width: 100 }} alt="" role="button" onClick={() => setCategory('Condominium')} />
                        </div>
                    </div>

                    <div className="col-4 col-md-2">
                        <div className="h-100 p-2">
                            <img src={foreclosure} className="img-fluid" style={{ width: 100 }}  alt="" role="button" onClick={() => setCategory('Foreclosure')} />
                        </div>
                    </div>

                    <div className="col-4 col-md-2">
                        <div className="h-100 p-2">
                            <img src={land} className="img-fluid" style={{ width: 100 }}  alt="" role="button" onClick={() => setCategory('Land')} />
                        </div>
                    </div>

                    <div className="col-4 col-md-2">
                        <div className="h-100 p-2">
                            <img src={lot} className="img-fluid" style={{ width: 100 }}  alt="" role="button" onClick={() => setCategory('Lot')} />
                        </div>
                    </div>

                    </div>

                </div>
                

                <br />
                { category && <h1>{category}</h1> }

                <div className="row g-2">
                    {
                        properties && properties.map(i => (
                            <a href={`property/${i[0]}`} className="col-6 col-md-2">
                                <div className="h-100 rounded-3 border">
                                    <img src={i[1].image_url} className="img-fluid mb-2" alt={i[1].title} />
                                    <div className="p-2">
                                        <span className="fw-bold d-block text-center mb-1">{(i[1].name).substring(0, 20)}</span>
                                        <small className="d-block">{(i[1].description).substring(0, 60)}</small>
                                        <span className="d-block text-success fw-bold mb-2">{formatter.format(i[1].price)}</span>
                                        
                                        <div className="">
                                            <small className="d-inline-block mx-1"><BsRulers /> { i[1].attributes.size }</small>
                                            <small className="d-inline-block mx-1"><FaBed /> { i[1].attributes.bedroom }</small>
                                            <small className="d-inline-block mx-1"><FaShower /> { i[1].attributes.comfortroom }</small>
                                            <small className="d-inline-block mx-1"><AiFillCar /> { i[1].attributes.parking }</small>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        ))
                    }
                </div>
            </div>
        </>
    )
}